(ns z-eines.impl
  (:require
   [cognitect.transit :as t]
   [frontend.logging :as logging]))

;;
;; State:
;;

(defonce state
  (atom {:socket nil
         :rsvp   {:request-id 0
                  :requests   {}}}))

;;
;; Message pack & unpack with transit:
;;

(def pack
  (let [writer (t/writer :json)]
    (fn [message]
      (t/write writer message))))

(def unpack
  (let [reader (t/reader :json)]
    (fn [message]
      (t/read reader message))))

;;
;; RSVP stuff:
;;

(defn rsvp-response
  [message on-message]
  (let [response-id (-> message
                        :headers
                        :eines/rsvp-response-id)
        response-fn (-> @state
                        :rsvp
                        :requests
                        (get response-id)
                        :response-fn)]
    (swap! state update-in
           [:rsvp :requests]
           (fn [requests]
             (when-let [{:keys [timeout]} (get requests response-id)]
               (js/clearTimeout timeout))
             (dissoc requests response-id)))
    (when response-fn
      (response-fn message))
    (if-not on-message
      (logging/warn "Eines impl -> No Message hander defined " message)
      (on-message message))))

(defn set-timeout
  [request-id timeout]
  (js/setTimeout
   (fn [_]
     (rsvp-response {:type    :eines.type/timeout
                     :headers {:eines/rsvp-response-id request-id}}
                    (:on-message @state)))
   timeout))

(defn push-rsvp
  [rsvp response-fn timeout]
  (let [request-id (-> rsvp
                       :request-id
                       inc)]
    (-> rsvp
        (assoc :request-id request-id)
        (assoc-in [:requests request-id]
                  {:response-fn response-fn
                   :timeout     (set-timeout request-id timeout)}))))

(defn rsvp-request-id
  [response-fn timeout]
  (-> (swap! state update :rsvp push-rsvp response-fn timeout)
      :rsvp
      :request-id))

;;
;; Connection polling:
;;

(defn deliver
  [message on-message]
  (let [response (on-message message)]
    (when-let [rsvp-request-id (-> message
                                   :headers
                                   :eines/rsvp-request-id)]
      (when state
        (when-let [socket (:socket @state)]
          (logging/debug "EINES deliver " rsvp-request-id)
          (.send socket
                 (-> response
                     (assoc-in [:headers :eines/rsvp-response-id] rsvp-request-id)
                     (assoc :type :eines.type/response)
                     (pack))))))))

(defn handle-message
  [e socket on-message]
  (let [message (->> e
                     .-data
                     unpack)]
    #_(when (and (not (some #{(:type message)} [:eines.type/pong :eines.type/ping])))
        (js/console.log "WS message : "
                        (:type message)
                        " --> delivered in "
                        (- (c-time/now-millis) (:server-time message))
                        "ms"))
    (when socket
      (case (:type message)
        :eines.type/pong nil
        :eines.type/ping (.send socket (pack {:type :eines.type/pong}))
        :eines.type/request (deliver message on-message)
        :eines.type/response (rsvp-response message on-message))
      nil)))

(defn ping!
  []
  (when state
    (when-let [socket (:socket @state)]
      (.send socket (pack {:type :eines.type/ping})))))

(defn clear-state
  [{:keys [socket interval] :as state-arg}]
  (when socket
    (set! (.-onclose socket) nil)
    (set! (.-onopen socket) nil)
    (set! (.-onmessage socket) nil)
    (set! (.-onerror socket) nil)
    (swap! state dissoc :socket))
  (when interval
    (js/clearInterval interval))
  (try
    (when socket
      (.close socket))
    (catch js/Object e
      (js/console.log "Could not close socket " e)))
  state-arg)

(defn set-socket!
  [state new-socket interval-fn interval-ms]
  #_(logging/info "Eines : set-socket!")
  (-> state
      (assoc :socket new-socket
             :interval (js/setInterval interval-fn interval-ms))))

(defn make-url
  [url format]
  (str url "?format=" (js/encodeURIComponent (name format))))

(defn connect!
  []
  (when state
    (let [{:keys [url format on-message on-connect on-close on-error]} @state
          socket (try
                   (js/WebSocket. (make-url url format))
                   (catch js/Object e
                     (js/console.log "Error creating websocket " e)
                     (on-error e)))
          rs (aget socket "readyState")]
      (if-not (and socket rs)
        (do
          (js/console.log "NO SOCKET")
          (if-not (fn? on-error)
            (js/console.log "Socket error handler not set")
            (on-error :websocket.status/not-available)))
        (do
          (swap! state assoc
                 :socket socket
                 :authenticated? false)
          (deref state)
          (when socket
            (set! (.-onopen socket)
                  (fn [_]
                    (swap! state set-socket! socket ping! 3000)
                    (on-connect)))
            (set! (.-onclose socket)
                  (fn [args]
                    (logging/error "Socket closed : " args)
                    (on-close args)))
            (set! (.-onerror socket)
                  (fn [args]
                    (logging/error "Socket error : " args)
                    (try
                      (on-error args)
                      (catch js/Object e
                        (logging/error "Error cleaning up socket " e)))))
            (set! (.-onmessage socket)
                  (fn [e]
                    (handle-message e socket on-message)))))))))

;;
;; Reset state:
;;

(defn reset-state
  [prev-state new-state]
  #_(logging/info "Eines : reset-state << " prev-state " >> " new-state)
  (clear-state prev-state)
  new-state)
